module.exports = __webpack_public_path__ + "img/12.bde2eed9.jpg";